import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { MatTableDataSource } from '@angular/material/table';
import { IconModule, LinkModule, LoaderModule, ScrollbarModule, TableConfig, TableModule } from '@michelin/theme';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ImportFileCsvStatus } from 'src/app/interfaces/importFileCsvStatus';
import { UtilService } from 'src/app/util/util.service';
import { ImportFileService } from '../import-file.service';

@Component({
  selector: 'mic-app-historic-modal',
  templateUrl: './historic-modal.component.html',
  styleUrls: ['./historic-modal.component.scss'],
  imports: [
    MatDialogTitle,
    MatIcon,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    ScrollbarModule,
    LoaderModule,
    TableModule,
    LinkModule,
    IconModule
  ]
})
export class HistoricModalComponent implements OnInit {
  readonly dialogRef = inject<MatDialogRef<HistoricModalComponent>>(MatDialogRef);
  readonly data = inject(MAT_DIALOG_DATA);
  readonly utilService = inject(UtilService);
  private readonly fileService = inject(ImportFileService);
  private readonly cdr = inject(ChangeDetectorRef);

  private readonly DEBOUNCE_TIME = 200;
  dataSource = new MatTableDataSource();

  search = new FormControl();
  importFileCsvStatus: any;
  ngOnInit(): void {
    this.fileService.getStatusesByImportFileId(this.data).subscribe((result) => {
      this.dataSource.data = result;
      this.cdr.detectChanges();
    });
    this.search.valueChanges.pipe(debounceTime(this.DEBOUNCE_TIME), distinctUntilChanged()).subscribe((search: string) => {
      this.dataSource.filter = search.trim().toLowerCase();
    });
  }

  tableConfig: TableConfig<ImportFileCsvStatus> = {
    onRowExpand: () => {},
    columns: {
      name: { cell: (elm: ImportFileCsvStatus) => elm.userName.toString(), header: 'Name' },
      date: { cell: (elm: ImportFileCsvStatus) => elm.startDate.toString().slice(0, 10), header: 'Date' },
      staus: { cell: 'status', header: 'Status', align: 'center' },
      file: { cell: 'file', header: '', align: 'center' }
    }
  };

  onNoClick(): void {
    this.dialogRef.close();
  }
  onClose() {
    this.onNoClick();
  }

  fileLink(statusId: number) {
    this.fileService.downloadFile(statusId).subscribe((response) => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.body);
      link.download = 'File.csv';
      link.click();
      window.URL.revokeObjectURL(link.href);
    });
  }
}
